// Magnifying glass for the triage search field.
// Decorative — the control it sits in carries the accessible name, so the glyph
// is aria-hidden. Size via CSS font-size (renders at 1em); color via currentColor.
export function SearchIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <circle cx="10.8" cy="10.8" r="6.8" />
      <line x1="15.8" y1="15.8" x2="21" y2="21" />
    </svg>
  );
}
